import React, { memo } from "react";
import {
  Button,
  PageHeader,
  PagePanel,
  PageShell,
  SearchableSelect,
  Select,
} from "../../../components/ui";
import { useAddEmployeeAttendance } from "./useAddEmployeeAttendance";

const AddEmployeeAttendance = () => {
  const {
    branchList,
    yearList,
    months,
    addBrData,
    changeData,
    excelLoading,
    downloadExcel,
  } = useAddEmployeeAttendance();

  return (
    <PageShell>
      <PageHeader
        title="Branch Attendance Report"
        subtitle="Generate a monthly attendance export for the selected branch."
      />

      <PagePanel padding="md">
        <div className="att-add-empattendance__form">
          <div className="att-add-empattendance__grid">
            <SearchableSelect
              id="att-add-empattendance-branch"
              label="Branch Name"
              placeholder="Select Branch Name"
              value={addBrData.LocationId || ""}
              onChange={(val) =>
                changeData({
                  target: { name: "LocationId", value: val ?? 0 },
                })
              }
              options={branchList.map((branch) => ({
                value: branch.LocationId,
                label: branch.LocationName,
              }))}
              emptyMessage="No branches match your search"
            />

            <Select
              id="att-add-empattendance-year"
              label="Year"
              name="Year"
              value={addBrData.Year}
              onChange={changeData}
            >
              <option value="">Select Year</option>
              {yearList.map((y, index) => (
                <option value={y.year} key={index}>
                  {y.year}
                </option>
              ))}
            </Select>

            <Select
              id="att-add-empattendance-month"
              label="Month"
              name="Month"
              value={addBrData.Month}
              onChange={changeData}
            >
              <option value="">Select Month</option>
              {months.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </Select>
          </div>

          <div className="att-add-empattendance__actions">
            <Button
              variant="primary"
              loading={excelLoading}
              onClick={downloadExcel}
            >
              Download Excel
            </Button>
          </div>
        </div>
      </PagePanel>
    </PageShell>
  );
};

export default memo(AddEmployeeAttendance);
